
/**
 * Utility functions for handling status mappings and display names
 */

// Convert status to display name
export const getStatusDisplayName = (status: string): string => {
  switch (status) {
    case "open":
    case "actie_luijten":
      return "Actie Luijten";
    case "in_behandeling":
    case "actie_decoprof":
      return "Actie Decoprof";
    case "actie_winkel_ridderkerk":
      return "Actie winkel Ridderkerk";
    case "opgelost":
    case "afgerond":
      return "Afgerond";
    case "afwachting_klant":
      return "In afwachting van klant";
    case "afwachting_voorraad":
      return "In afwachting van nieuwe voorraad";
    case "afwachting_voorraad_ridderkerk":
      return "In afwachting van nieuwe voorraad winkel Ridderkerk";
    case "afwijkende_verzenddatum":
      return "Afwijkende verzenddatum";
    case "all":
      return "Alle statussen";
    default:
      return status;
  }
};

// Status options for select dropdown
// Check if a status is awaiting stock
export const isAwaitingStockStatus = (status: string): boolean => {
  return status === "afwachting_voorraad" 
    || status === "afwachting_voorraad_ridderkerk"
    || status === "open"
    || status === "actie_luijten"
    || status === "in_behandeling"
    || status === "actie_decoprof";
};

// Status options for select dropdown
export const statusOptions = [
  { value: "all", label: "Alle statussen" },
  { value: "open", label: "Actie Luijten" },
  { value: "in_behandeling", label: "Actie Decoprof" },
  { value: "actie_winkel_ridderkerk", label: "Actie winkel Ridderkerk" },
  { value: "afwachting_klant", label: "In afwachting van klant" },
  { value: "afwachting_voorraad", label: "In afwachting van nieuwe voorraad" },
  { value: "afwachting_voorraad_ridderkerk", label: "In afwachting van nieuwe voorraad winkel Ridderkerk" },
  { value: "afwijkende_verzenddatum", label: "Afwijkende verzenddatum" },
  { value: "opgelost", label: "Afgerond" },
];
